import { Pipe, PipeTransform } from '@angular/core';
import { map, round, sum } from 'lodash';

export interface DynamicTablesSummary {
  amount: number;
  percentage: number;
}

@Pipe({
    name: 'sectionSummary',
    standalone: false
})
export class DynamicTablesSectionSummaryPipe implements PipeTransform {
  transform(
    value: Record<string, number>,
    fieldIds: string[]
  ): DynamicTablesSummary {
    const amount: number = sum(map(fieldIds, (id: string) => value[id]));
    const percentage: number =
      round((100 * amount) / value['_declaredValue'], 2) || 0;

    return { amount, percentage };
  }
}
